import { render, staticRenderFns } from "./sk-radio-wap.vue?vue&type=template&id=15ed93f0&scoped=true&"
import script from "./sk-radio-wap.vue?vue&type=script&lang=js&"
export * from "./sk-radio-wap.vue?vue&type=script&lang=js&"
import style0 from "./sk-radio-wap.vue?vue&type=style&index=0&id=15ed93f0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed93f0",
  null
  
)

export default component.exports